var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.997a.8.8 0 0 1-.567-.235c-.15-.15-.235-.355-.235-.567V14.07a2.37 2.37 0 0 1 1.567-2.205 2.4 2.4 0 0 0 .597-4.228 2.4 2.4 0 0 0-3.784 1.978.8.8 0 0 1-.037.33c-.035.106-.092.204-.168.287s-.167.149-.269.194-.213.069-.325.069a.79.79 0 0 1-.325-.069c-.102-.046-.194-.112-.269-.194s-.132-.181-.167-.287-.048-.219-.037-.33a4 4 0 0 1 4.262-4.009c.732.049 1.437.298 2.037.72a4 4 0 0 1-.974 7.039.75.75 0 0 0-.503.75v1.095a.8.8 0 0 1-.803.787zM12 24A12 12 0 0 1 .23 9.659 12 12 0 0 1 9.659.231a12 12 0 0 1 6.933.683A12 12 0 0 1 12 24zm0-22.402a10.4 10.4 0 0 0-5.779 1.753 10.41 10.41 0 0 0-3.832 4.668A10.4 10.4 0 0 0 9.97 22.203c2.018.401 4.11.195 6.01-.592s3.525-2.121 4.669-3.831 1.753-3.722 1.753-5.779A10.41 10.41 0 0 0 12 1.598zm-.001 16.8c-.106.001-.21-.019-.308-.059s-.187-.099-.262-.174a.8.8 0 0 1 .328-1.337.8.8 0 0 1 .942.385c.088.163.117.352.082.534a.8.8 0 0 1-.783.65z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.6941cc49dd28737f48370fd43319e925.svg";
export { ForwardRef as ReactComponent };